<template>
  <div id="tab1" class="t-color-gray2 pdl-16 pdr-16 pdt-16 pdb-34">
    <!-- <div class="h-50"></div>
        <div class="h-32"></div> -->
    <img
      src="/images/helpdesk/notice_nodata.svg"
      alt=""
      class="mgx-auto no-data-image"
    />
    <!-- <div
      class="pdt-24 pdl-16 pdr-16 pdb-4 t-subtitle3 t-color-title t-center font-m l-spacing48"
    >
      {{ $t("3067") }}
    </div> -->
    <div
      class="pdt-4 mgt-24 pdl-16 pdr-16 pdb-4 t-body3 t-color-content1 t-center l-spacing42"
    >
      {{ $t("S20003") }}
    </div>
  </div>
</template>

<script>
/**
 * 나의 학습 메인 컴포넌트(my learn main component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import TopAppBar from "@/components/TopAppBar.vue";
import { topAppBarMixin } from "@/mixins/topAppBar.js";
//import HelpDeskList from '@/components/helpDesk/List'
import { MDCTabBar, MDCTabBarFoundation } from "@material/tab-bar";

export default {
  name: "learn",

  data() {
    return {
      // title
      leftBtnMethod: () => {
        this.$router.go(-1);
      },
      tabBar: null,
    };
  },
  components: {
    TopAppBar,
    //HelpDeskList,
    // Faq: () => import("@/components/helpDesk/Faq.vue"),
    // Inqueriy: () => import("@/components/helpDesk/Inqueriy.vue"),
  },

  mixins: [topAppBarMixin],

  watch: {
    $route(to, from) {},
  },

  // mounted() {
  //   //this.setTopAppBarHomeBlank(this.$t('66'))
  //   $(document).ready(function () {
  //     $(".tabs").tabs();
  //   });
  //   this.tabBar = new MDCTabBar(document.querySelector(".mdc-tab-bar"));
  //   this.setTabActive();
  //   this.setTopAppBarBackSearch(this.$t("1496"));
  // },

  // methods: {
  //   setTabActive() {
  //     let status = this.$route.query.status;
  //     if (status === "FAQ") {
  //       this.tabBar.activateTab(0);
  //     } else if (status == "INQUERY") {
  //       this.tabBar.activateTab(1);
  //     } else {
  //       this.tabBar.activateTab(0);
  //     }
  //   },
  // },
};
</script>

<style scoped>
.fixed-header {
  position: fixed;
  top: 0;
}
.nav-extended .brand-logo,
.nav-content * {
  font-family: noto-regular;
}

.nav-extended .brand-logo {
  font-size: 20px;
  letter-spacing: -0.6;
}

.tabs .tab a:focus,
.tabs .tab a:focus.active {
  background-color: #f5f5f5;
  outline: none;
}

.tabs .indicator {
  background: #2d6dcc;
}

.mdc-elevation--z3 {
  border-radius: 4px;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.26);
  background-color: #ffffff;
}

.tabs .tab {
  width: 50%;
}
.listItems {
  border-bottom: 1px solid #e6eced;
}
.no-data-image {
  width: 123px;
  height: 143px;
}

#tab1,
#tab2 {
  margin-top: 56px;
}
</style>